module.exports = __webpack_public_path__ + "img/icon_tree_dot.5a104b48.svg";